import { call } from '../../utils/serviceUtils';
import {
  PROCESS_GROUP_GET,
  PROCESS_GROUP
  } from '../../config/paths';


export function getProcessGroups() {
  return call.get(PROCESS_GROUP_GET,
    {

    });
}

export function deleteProcessGroupById(id) {
  return call.delete(PROCESS_GROUP+'/'+id,
  {
    
  });
}

export function createProcessGroup(data) {
  return call.post(PROCESS_GROUP,data);
}

export function updateProcessGroup(id,data) {
  return call.put(PROCESS_GROUP+'/'+id,data);
}


